import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { showErrorMessage, showSuccessMessage, showWarningMessage } from './toast.message.actions';
import { tap } from 'rxjs/operators';
import { ToasterService } from 'src/app/shared/services/global/toast-service';

@Injectable()
export class ToastMessageEffects {
    constructor(
        private actions$: Actions,
        private toastService: ToasterService
    ) { }

    showErrorMessage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(showErrorMessage),
            tap(({ response }) => {
                this.toastService.showError(response as string);
            })
        ), { dispatch: false }
    );


    showSuccessMessage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(showSuccessMessage),
            tap(({ response }) => {
                this.toastService.showSuccess(response as string);
            })
        ), { dispatch: false }
    );

    showWarningMessage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(showWarningMessage),
            tap(({ response }) => {
                this.toastService.showWarning(response as string);
            })
        ), { dispatch: false });
}
